import classNames from 'classnames';
import React, { useState, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { apiRoot } from '../../../../../infrastructure/api';
import axios from '../../../../../utils/secured-axios';
import Button, { ButtonSize } from '../../../../../atoms/buttons/Button';
import css from './PurchaseVerifyUserAlert.module.scss';

interface ElementProps {
  labelType: string;
}

type Props = ElementProps;

const PurchaseVerifyUserAlert: React.FC<Props> = (props) => {
  const { labelType } = props;
  const intl = useIntl();
  const [submitted, setSubmitted] = useState<boolean>(false);

  const handleSubmit = useCallback(async () => {
    try {
      await axios.get(`${apiRoot()}/users/send_verification`);
      setSubmitted(true);
    } catch (e) {
      // error
    }
  }, []);

  const classes = classNames(css.PurchaseVerifyUserAlert);

  return (
    <div className={classes}>
      <div className={css.PurchaseVerifyUserAlert__Title}>
        {intl.formatMessage({
          id: 'purchases.purchaseVerifyUserAlert.title',
        })}
      </div>
      <div className={css.PurchaseVerifyUserAlert__Description}>
        {intl.formatMessage({
          id: `purchases.purchaseVerifyUserAlert.description.${labelType}`,
        })}
      </div>
      <Button
        isFull={true}
        disabled={submitted}
        buttonSize={ButtonSize.Medium}
        onClick={handleSubmit}
      >
        {intl.formatMessage({
          id: `purchases.purchaseVerifyUserAlert.submitButton.${
            submitted ? 'submitted' : 'submit'
          }`,
        })}
      </Button>
    </div>
  );
};

export default PurchaseVerifyUserAlert;
